import React, { useState } from 'react';
import './DemoRequest.css';

function DemoRequest() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    companySize: '',
    phone: '',
    message: ''
  });
  
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      // Create mailto link as fallback
      const subject = `F-IT Score Demo Request from ${formData.company}`;
      const body = `
Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company}
Company Size: ${formData.companySize}
Phone: ${formData.phone}

Message:
${formData.message}
      `;
      
      const mailtoLink = `mailto:hello@f-itscore.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;
      
      setStatus('success');
      setFormData({
        name: '',
        email: '',
        company: '',
        companySize: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="demo-request-page">
      <section className="demo-hero">
        <div className="container">
          <h1>Request a Demo</h1>
          <p className="lead">See F-IT Score in action with a personalised demonstration</p>
        </div>
      </section>

      <section className="demo-content">
        <div className="container">
          <div className="demo-grid">
            <div className="demo-info">
              <h2>What to Expect</h2>
              <div className="expect-item">
                <div className="expect-icon-circle">
                  <span>✓</span>
                </div>
                <div>
                  <h3>Live Platform Demo</h3>
                  <p>We'll walk you through the F-IT Score platform, showing both the individual user experience and the company&nbsp;dashboard.</p>
                </div>
              </div>
              <div className="expect-item">
                <div className="expect-icon-circle">
                  <span>→</span>
                </div>
                <div>
                  <h3>Your Use Cases</h3>
                  <p>Discuss your organisation's specific needs and see how F-IT Score can address your wellbeing&nbsp;challenges.</p>
                </div>
              </div>
              <div className="expect-item">
                <div className="expect-icon-circle">
                  <span>↔</span>
                </div>
                <div>
                  <h3>Custom Consultation</h3>
                  <p>Get answers to your questions and explore pricing, implementation timelines, and integration&nbsp;options.</p>
                </div>
              </div>
              <div className="expect-item">
                <div className="expect-icon-circle">
                  <span>◷</span>
                </div>
                <div>
                  <h3>45-Minute Session</h3>
                  <p>Demos typically last 45 minutes and can be scheduled at your convenience - no pressure, no&nbsp;obligation.</p>
                </div>
              </div>
            </div>

            <div className="demo-form-container">
              <form onSubmit={handleSubmit} className="demo-form">
                <h2>Get Started</h2>
                
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Work Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company Name *</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="companySize">Company Size *</label>
                  <select
                    id="companySize"
                    name="companySize"
                    value={formData.companySize}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select size...</option>
                    <option value="1-50">1-50 employees</option>
                    <option value="51-200">51-200 employees</option>
                    <option value="201-500">201-500 employees</option>
                    <option value="501-1000">501-1000 employees</option>
                    <option value="1000+">1000+ employees</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Tell us about your needs</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="What are your main wellbeing challenges? What would you like to see in the demo?"
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-orange" disabled={status === 'sending'}>
                  {status === 'sending' ? 'Sending...' : 'Request Demo'}
                </button>

                {status === 'success' && (
                  <div className="form-message success">
                    Thank you! Your demo request has been sent. We'll be in touch within 24 hours.
                  </div>
                )}
                {status === 'error' && (
                  <div className="form-message error">
                    Sorry, there was an error. Please email us directly at hello@f-itscore.com
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DemoRequest;
